const API_ROOT = import.meta.env.VITE_API_ROOT || '/api/v1'

function browserId() {
  let id = localStorage.getItem('promptguess-browser-id')
  if (!id) {
    id = crypto.randomUUID()
    localStorage.setItem('promptguess-browser-id', id)
  }
  return id
}

let fingerprintPromise
function deviceFingerprint() {
  fingerprintPromise ||= (async () => {
    const signals = [navigator.userAgent, navigator.language, navigator.platform,
      navigator.hardwareConcurrency, navigator.maxTouchPoints, screen.width, screen.height,
      Intl.DateTimeFormat().resolvedOptions().timeZone].join('|')
    const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(signals))
    return Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('')
  })()
  return fingerprintPromise
}

async function identityHeaders() {
  try { return { 'X-Browser-Id': browserId(), 'X-Device-Fingerprint': await deviceFingerprint() } }
  catch { return {} }
}

export class ApiError extends Error {
  constructor(message, status) {
    super(message)
    this.status = status
  }
}

export async function api(path, options = {}) {
  const token = localStorage.getItem('promptguess-token')
  const identity = await identityHeaders()
  const response = await fetch(`${API_ROOT}${path}`, {
    credentials: 'include',
    ...options,
    headers: {
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...identity,
      ...options.headers
    }
  })
  if (response.status === 204) return null
  const payload = await response.json().catch(() => ({}))
  if (!response.ok) throw new ApiError(payload.error || 'Не удалось выполнить запрос', response.status)
  return payload
}

export const post = (path, data) => api(path, { method: 'POST', body: JSON.stringify(data) })
export const patch = (path, data) => api(path, { method: 'PATCH', body: JSON.stringify(data) })

export async function imageBlob(path) {
  const token = localStorage.getItem('promptguess-token')
  const response = await fetch(`${API_ROOT}${path}`, { credentials: 'include', headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}), ...await identityHeaders() } })
  if (!response.ok) throw new ApiError('Изображение недоступно', response.status)
  return response.blob()
}
